import { CONSTANT } from '../../constant/constant';
import { ENDPOINTS } from '../../constant/endpoints';
import { generalHttpGetRequest } from '../../helper/request-helper';

const fetchCountriesUrl =
    CONSTANT.baseUrl + ENDPOINTS.commonData.fetchCountries;
const fetchStatesUrl = CONSTANT.baseUrl + ENDPOINTS.commonData.fetchStates;
const fetchFundTypesUrl =
    CONSTANT.baseUrl + ENDPOINTS.commonData.fetchFundTypes;
const fetchFundFilingTypesUrl =
    CONSTANT.baseUrl + ENDPOINTS.commonData.fetchfundFilingTypes;
const fetchRenewalCycleTypesUrl =
    CONSTANT.baseUrl + ENDPOINTS.commonData.fetchRenewalCycleTypes;
const fetchPaymentTypesUrl =
    CONSTANT.baseUrl + ENDPOINTS.commonData.fetchPaymentTypes;
const fetchPermitNumberTypesUrl =
    CONSTANT.baseUrl + ENDPOINTS.commonData.fetchPermitNumberTypes;
const fetchMailingMethodTypesUrl =
    CONSTANT.baseUrl + ENDPOINTS.commonData.fetchMailingMethodTypes;

export const actionType = {
    REQUESTED_COMMON_DATA: 'REQUESTED_COMMON_DATA',
    REJECTED_COMMON_DATA: 'REJECTED_COMMON_DATA',
    FETCH_COUNTRIES: 'FETCH_COUNTRIES',
    FETCH_STATES: 'FETCH_STATES',
    FETCH_FUND_TYPES: 'FETCH_FUND_TYPES',
    FETCH_FUND_FILING_TYPES: 'FETCH_FUND_FILING_TYPES',
    FETCH_RENEWAL_CYCLE_TYPES: 'FETCH_RENEWAL_CYCLE_TYPES',
    FETCH_PAYMENT_TYPES: 'FETCH_PAYMENT_TYPES',
    FETCH_PERMIT_NUMBER_TYPES: 'FETCH_PERMIT_NUMBER_TYPES',
    FETCH_MAILING_METHOD_TYPES: 'FETCH_MAILING_METHOD_TYPES'
};

export const fetchCountries = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchCountriesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_COUNTRIES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};

export const fetchStates = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchStatesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_STATES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};

export const fetchFundTypes = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchFundTypesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_FUND_TYPES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};

export const fetchFundFilingTypes = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchFundFilingTypesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_FUND_FILING_TYPES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};

export const fetchRenewalCycleTypes = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchRenewalCycleTypesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_RENEWAL_CYCLE_TYPES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};

export const fetchPaymentTypes = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchPaymentTypesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PAYMENT_TYPES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};

export const fetchPermitNumberTypes = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchPermitNumberTypesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PERMIT_NUMBER_TYPES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};

export const fetchMailingMethodTypes = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_COMMON_DATA
        });

        return generalHttpGetRequest(fetchMailingMethodTypesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_MAILING_METHOD_TYPES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_COMMON_DATA,
                    data: error
                });
            });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/commonData/actions.js